import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Health of the nightly database + photo backups. Polled every 5 minutes —
// backups only change once a day, so this is just to keep a long-open tab
// roughly current.
export function useBackups() {
  return useQuery({
    queryKey: ['platform', 'backups'],
    queryFn: async () => {
      const { data } = await api.get('/api/platform/backups');
      return data;
    },
    refetchInterval: 300_000,
    refetchOnWindowFocus: true,
  });
}
